import(/* webpackMode: "eager", webpackExports: ["CopyButton"] */ "/app/components/copy-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Reveal"] */ "/app/components/reveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/app/components/site-header.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"components/brand-page.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"400\",\"600\"],\"subsets\":[\"latin\",\"latin-ext\"],\"display\":\"swap\",\"preload\":false}],\"variableName\":\"specimen\"}");
